import { fieldsForApproving, IFieldForApprovingContext } from '../constants/fieldsForApproving';
import { checkFillValue } from './checkFillValue';

interface IKnmErknmGetFillStatusByField {
  name?: string;
  value?: unknown;
  pairedValues?: {
    [k: string]: unknown;
  };
  isNested?: boolean;
  pairedByNestedValue?: unknown;
  context: IFieldForApprovingContext;
}

export const knmErknmGetFillStatusByField = ({
  name,
  value,
  pairedValues,
  isNested,
  pairedByNestedValue,
  context,
}: IKnmErknmGetFillStatusByField) => {
  if (isNested) {
    // checking nested in array and paired by nested
    const isFillPaired = !checkFillValue(pairedByNestedValue);

    if (!isFillPaired && pairedByNestedValue) {
      return false;
    }

    return !checkFillValue(value);
  }
  const currentField = fieldsForApproving.find(item => item.name === name && !item.nested);

  if (currentField) {
    const { paired, requiredFieldName } = currentField;
    // main status of name
    const isDefaultStatus =
      !checkFillValue(value, requiredFieldName) &&
      (!currentField.additionalCondition || currentField.additionalCondition(value, context));

    if (paired) {
      // checking paired by AdditionalCondition
      const isCorrectConditionalAdditional = paired.every(pairedItem => {
        const { name: pairedName, getAdditionalCondition } = pairedItem;

        if (getAdditionalCondition && pairedValues) {
          return getAdditionalCondition(pairedValues[pairedName]);
        }

        return true;
      });

      if (!isCorrectConditionalAdditional) {
        return false;
      }

      // checking paired by filled
      const isFillSomePaired = paired.some(pairedItem => {
        const { name: pairedName, getAdditionalCondition } = pairedItem;

        if (!getAdditionalCondition) {
          return checkFillValue(
            pairedValues ? pairedValues[pairedName] : undefined,
            fieldsForApproving.find(field => field.name === pairedName)?.requiredFieldName,
          );
        }

        return false;
      });

      if (isFillSomePaired) {
        return !isFillSomePaired;
      }

      return isDefaultStatus;
    }

    return isDefaultStatus;
  }
};
